import { Component } from 'react';
import $ from 'jquery';
import moment from 'moment-timezone/moment-timezone';
import styles from 'styles/chrome';

export default class Clock extends Component {
	constructor(props) {
		super(props);

		this.setTime = this.setTime.bind(this);
	}

	componentDidMount() {
		this.$time = $(this.refs.time);

		// Update clock every 1 second
		this.interval = setInterval(this.setTime, 1000);
	}

	componentWillUnmount() {
		this.interval = clearInterval(this.interval);
	}

	setTime() {
		this.$time.text(this.getTime());
	}

	getTime() {
		return moment().format('HH:mm:ss');
	}

	render() {
		return (
			<div className={styles.panel}>
				<span className={styles.copyAside}>Time in Pyeongchang</span>
				<span ref="time" className={styles.copyMain}>{this.getTime()}</span>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./scripts/components/Clock.es6